import { defineStore } from 'pinia';
import type { Ref } from 'vue';
import { ref } from 'vue';
import { Language } from '@getaccept/lib-shared-new/src/languages/enums/language';
import { loadLanguageAsync } from '../../i18n/lang';
import { isSupportedLanguage } from '../../helpers/language';
export const useLanguageStore = defineStore('language', () => {
  const language: Ref<Language> = ref(Language.En);

  const setLanguage = async (newLanguage: Language) => {
    language.value = isSupportedLanguage(newLanguage) ? newLanguage : Language.En;
    await loadLanguageAsync(newLanguage);
  };

  return {
    language,
    setLanguage,
  };
});
